const LEGACY_ROLE_MAP = Object.freeze({
  client_admin: 'facility_admin',
  client_manager: 'facility_manager',
  client_worker: 'facility_worker',
});

export function normalizeRole(role) {
  const normalized = String(role || '').trim();
  return LEGACY_ROLE_MAP[normalized] || normalized;
}

export function normalizeUserRole(user) {
  if (!user) return user;
  return {
    ...user,
    role: normalizeRole(user.role),
  };
}
